export const tiktok = () => (
  <>
    <path
      d="M21.18 6.264v3.779a8.97 8.97 0 01-5.264-1.694v7.685a6.959 6.959 0 11-6.023-6.886v3.835a3.305 3.305 0 00-.935-.144 3.196 3.196 0 00-1.47 5.991 3.196 3.196 0 004.641-2.652V1h3.779a5.258 5.258 0 002.397 4.41c.854.56 1.854.857 2.875.854z"
      fill="inherit"
    />
  </>
);
